import { get } from './http';

export const getProducts = async (products, channelId) => {
  const response = await get(
    `/api/shoppinglist?products=${products}&channelId=${channelId}`
  );
  return response.json();
};

